import React, {Component} from "react";
import {Avatar} from "@vkontakte/vkui";
import {AdaptivityContext} from "../assets/constants";
import Dexie from "dexie";

class PhotoWrapper extends Component {

    constructor(props) {
        super(props);
        this.dbName = "PhotoUploadDB";
        this.storeName = "photos";
        this.state = {
            imageUrl: null, // Сначала null, пока не проверим локальную базу
            uploadProgress: null,
            isCheckingLocal: true // Флаг для контроля первичной проверки
        };
        this.db = new Dexie(this.dbName)
        this.db.version(4).stores({
            [this.storeName]: "++id, &filename, uri, destination, uploaded, &createdAt, uploadedAt, serverUrl, bookedTime, uploadProgress"
        })
    }
    
    async componentDidMount() {
        // Сначала проверяем локальную базу данных
        await this.checkLocalImageInitial();
        
        // Периодически проверяем обновления прогресса
        this.progressInterval = setInterval(() => {
            this.checkLocalImage();
        }, 1000);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.src !== this.props.src) {
            this.setState({imageUrl: null, uploadProgress: null, isCheckingLocal: true});
            this.checkLocalImageInitial();
        }
    }

    componentWillUnmount() {
        if (this.progressInterval) {
            clearInterval(this.progressInterval);
        }
    }

    getFilenameFromUrl(url) {
        try {
            const urlObj = new URL(url);
            const srcParam = urlObj.searchParams.get('src');
            if (srcParam) {
                return srcParam.split('/').pop();
            }
            // Fallback для старого формата URL
            return url.split('/').pop();
        } catch (e) {
            // Если URL некорректный, используем fallback
            return url.split('/').pop();
        }
    }

    async checkLocalImageInitial() {
        const filename = this.getFilenameFromUrl(this.props.src);
        
        try {
            const photo = await this.db[this.storeName].where('filename').equals(filename).toArray();
            
            if (photo.length > 0) {
                const photoRecord = photo[0];
                
                if (photoRecord.uploaded) {
                    // Файл полностью загружен - используем серверный
                    this.setState({
                        imageUrl:  this.props.src,
                        uploadProgress: null,
                        isCheckingLocal: false
                    });
                } else {
                    // Файл есть, но не загружен - показываем прогресс и локальный файл
                    this.setState({
                        imageUrl: photoRecord.uri,
                        uploadProgress: photoRecord.uploadProgress,
                        isCheckingLocal: false
                    });
                }
            } else {
                // Локального файла нет - используем серверный URL
                this.setState({
                    imageUrl: this.props.src,
                    uploadProgress: null,
                    isCheckingLocal: false
                });
            }
        } catch (error) {
            console.error('Ошибка при проверке локальной базы данных:', error);
            // В случае ошибки используем серверный URL
            this.setState({
                imageUrl: this.props.src,
                uploadProgress: null,
                isCheckingLocal: false
            });
        }
    }

    async checkLocalImage() {
        // Этот метод используется для периодической проверки прогресса
        if (this.state.isCheckingLocal) return; // Не запускаем, если идет первичная проверка
        
        const filename = this.getFilenameFromUrl(this.props.src);
        
        try {
            const photo = await this.db[this.storeName].where('filename').equals(filename).toArray();
            
            if (photo.length > 0) {
                const photoRecord = photo[0];
                
                // Обновляем только если файл еще не загружен
                if (!photoRecord.uploaded) {
                    this.setState({
                        imageUrl: photoRecord.uri,
                        uploadProgress: photoRecord.uploadProgress
                    });
                } else {
                    // Файл загружен - убираем прогресс
                    this.setState({
                        imageUrl: photoRecord.uri,
                        uploadProgress: null
                    });
                }
            } else if (this.state.imageUrl !== this.props.src || this.state.uploadProgress !== null) {
                this.setState({
                    imageUrl: this.props.src,
                    uploadProgress: null
                });
            }
        } catch (error) {
            console.error('Ошибка при проверке локальной базы данных:', error);
        }
    }

    renderFill() {
        const isUploading = this.state.uploadProgress !== null && this.state.uploadProgress < 100;
        const isLoading = this.state.isCheckingLocal || this.state.imageUrl === null;

        return (
            <div className="photo-wrapper--fill" style={{position: 'relative', width: '100%', height: '100%', ...this.props.style}}>
                {!isLoading
                    ? <img src={this.state.imageUrl} alt={this.props.alt || ''}
                           onError={(e) => { e.currentTarget.style.display = 'none'; }}/>
                    : <div className="angle-tile__cover-empty" aria-hidden="true"/>}
                {isUploading && !isLoading &&
                    <div className="photo-wrapper--fill-progress">
                        {this.state.uploadProgress}%
                    </div>}
            </div>
        );
    }

    render() {
        if (this.props.fill) {
            return this.renderFill();
        }

        const size = AdaptivityContext.isMobile ? 120 : 260;
        const isUploading = this.state.uploadProgress !== null && this.state.uploadProgress < 100;
        const isLoading = this.state.isCheckingLocal || this.state.imageUrl === null;
        
        return (
            <div style={{ position: 'relative', display: 'inline-block', ...this.props.style }}>
                {!isLoading ? (
                    <Avatar
                        src={this.state.imageUrl}
                        mode="image"
                        style={{
                            opacity: isUploading ? 0.8 : 1,
                            borderRadius: '5%',
                        }}
                        size={size}
                    />
                ) : (
                    // Показываем placeholder пока проверяем локальную базу данных
                    <div style={{
                        width: size,
                        height: size,
                        borderRadius: '5%',
                        backgroundColor: '#f0f0f0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#999'
                    }}>
                        {/* Можно добавить спиннер или другой индикатор загрузки */}
                        <div style={{ fontSize: size * 0.1 }}>...</div>
                    </div>
                )}
                
                {isUploading && !isLoading && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0, 0, 0, 0.1)',
                        opacity:  0.6,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column'
                    }}>
                        {/* Circular Progress */}
                        <div style={{
                            width: size * 0.6,
                            height: size * 0.6,
                            borderRadius: '50%',
                            background: `conic-gradient(#4CAF50 ${this.state.uploadProgress * 3.6}deg, rgba(255,255,255,0.3) 0deg)`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative'
                        }}>
                            {/* Inner circle */}
                            <div style={{
                                width: size * 0.45,
                                height: size * 0.45,
                                borderRadius: '50%',
                                background: 'rgba(255, 255, 255, 0.9)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: size * 0.1,
                                fontWeight: 'bold',
                                color: '#333'
                            }}>
                                {this.state.uploadProgress}%
                            </div>
                        </div>

                    </div>
                )}
            </div>
        )
    }
}

export default PhotoWrapper